import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { LocalizedLink } from '../components/LocalizedLink';
import NonIndexableHelmet from '../components/NonIndexableHelmet';

const USEFUL_LINKS = [
  { to: '/assistance-video/', labelKey: 'linkAssistanceVideo' },
  { to: '/guides/', labelKey: 'linkGuides' },
  { to: '/secteurs/', labelKey: 'linkSectors' },
  { to: '/faq/', labelKey: 'linkFaq' },
];

const NotFoundPage = () => {
  const { t } = useTranslation('notfound');
  const { isAuthenticated } = useAuth();

  return (
    <>
      <NonIndexableHelmet
        title={t('metaTitle')}
        description={t('metaDescription')}
      />
      <div className="auth-page-gradient not-found-shell">
        <Container>
          <Row className="justify-content-center align-items-center auth-page-shell">
            <Col md={8} lg={6} className="text-center text-white">
              <div className="not-found-code fw-bold opacity-25" aria-hidden="true">
                404
              </div>
              <h1 className="display-4 fw-bold mb-4">{t('title')}</h1>
              <p className="lead mb-4">{t('lead')}</p>
              <div className="d-flex gap-3 justify-content-center flex-wrap mb-4">
                <Button as={LocalizedLink} to="/" variant="light" size="lg">
                  <i className="bi bi-house-fill me-2" />
                  {t('home')}
                </Button>
                {isAuthenticated ? (
                  <Button as={LocalizedLink} to="/dashboard" variant="outline-light" size="lg">
                    <i className="bi bi-speedometer2 me-2" />
                    {t('dashboard')}
                  </Button>
                ) : (
                  <Button as={LocalizedLink} to="/login/" variant="outline-light" size="lg">
                    <i className="bi bi-box-arrow-in-right me-2" />
                    {t('login')}
                  </Button>
                )}
              </div>
              <nav
                className="text-start mx-auto"
                style={{
                  maxWidth: '24rem',
                  background: 'rgba(255,255,255,0.12)',
                  borderRadius: '0.75rem',
                  padding: '1rem 1.25rem',
                }}
                aria-label={t('usefulLinksTitle')}
              >
                <h2 className="h6 text-uppercase mb-3 opacity-75">{t('usefulLinksTitle')}</h2>
                <ul className="list-unstyled mb-0">
                  {USEFUL_LINKS.map(({ to, labelKey }) => (
                    <li key={to} className="mb-2">
                      <LocalizedLink to={to} className="text-white text-decoration-underline">
                        {t(labelKey)}
                      </LocalizedLink>
                    </li>
                  ))}
                </ul>
              </nav>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default NotFoundPage;
